var _circle, _path, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _circle2, _rect, _path2, _path3, _polygon10, _polygon11, _polygon12, _path4, _path5, _circle3, _path6, _polygon13, _path7, _polygon14, _path8, _path9, _ellipse, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndrawSolutionMindset34Bi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e1d6a9e2-5d0a-4358-9625-bb79dd06fec3",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 996,
    height: 674.00456,
    viewBox: "0 0 996 674.00456",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "solution_mindset") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 138.92463,
    cy: 525.44909,
    r: 138.92463,
    fill: "#f2f2f2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M408.97863,700.06688a293.53529,293.53529,0,1,1,207.55981-85.97449A291.6131,291.6131,0,0,1,408.97863,700.06688Zm0-584.82844c-160.61958,0-291.29359,130.67347-291.29359,291.29359s130.674,291.29413,291.29359,291.29413S700.27222,567.15215,700.27222,406.532,569.5982,115.23844,408.97863,115.23844Z",
    transform: "translate(-102 -112.99772)",
    fill: "#2f2e41"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "459.908 386.443 459.875 386.46 315.201 467.019 156.779 387.808 154.049 386.443 162.271 222.003 305.334 120.05 306.913 121.037 454.975 213.781 459.908 386.443",
    fill: "#6c63ff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "459.875 386.46 315.201 467.019 156.779 387.808 297.112 289.424 459.875 386.46",
    opacity: 0.3
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "459.908 386.443 297.112 289.424 306.913 121.037 454.975 213.781 459.908 386.443",
    opacity: 0.1
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "160.165 272.745 159.361 271.607 304.021 169.5 456.834 265.309 456.094 266.49 304.066 171.173 160.165 272.745",
    fill: "#f2f2f2"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "157.361 328.61 156.579 327.458 300.505 229.743 300.882 229.957 456.963 318.417 456.275 319.629 300.571 231.382 157.361 328.61",
    fill: "#f2f2f2"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "212.276 415.965 211.542 414.781 356.595 324.9 356.595 152.594 357.988 152.594 357.988 325.676 212.276 415.965",
    fill: "#f2f2f2"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "269.209 444.428 268.469 443.248 408.138 355.645 408.138 184.879 409.531 184.879 409.531 356.416 269.209 444.428",
    fill: "#f2f2f2"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "407.612 415.982 245.176 325.73 245.199 325.296 253.75 156.281 255.141 156.352 246.612 324.933 408.289 414.764 407.612 415.982",
    fill: "#f2f2f2"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "356.507 444.455 195.895 360.288 195.92 359.841 205.388 190.742 206.779 190.82 197.337 359.471 357.154 443.221 356.507 444.455",
    fill: "#f2f2f2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 487.35658,
    cy: 63.86079,
    r: 56.018,
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.49044,
    y: 662.13328,
    width: 963.50956,
    height: 2.24072,
    fill: "#2f2e41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M986.13709,473.81218l12.80452,35.07325s-13.36124,40.08372,0,41.19716S1013.973,511.669,1013.973,511.669l-7.23733-42.31059Z",
    transform: "translate(-102 -112.99772)",
    fill: "#ffb9b9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M992.261,359.12821l9.46421,9.46422v45.09418s5.56718,8.35077,4.45375,10.57764-2.22688,2.22688-1.11344,3.897,2.22687,2.78359,1.11344,3.897a4.17537,4.17537,0,0,0,0,5.01046c1.11343,1.11344,3.34031,2.7836,1.67015,4.45375s-3.897.55672-1.67015,6.68062,6.1239,7.79406,5.01046,10.02093-1.11343,7.79406-1.11343,7.79406l-23.93889,3.34031-5.01047-62.90917Z",
    transform: "translate(-102 -112.99772)",
    fill: "#d0cde1"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "909.189 352.464 881.353 353.577 882.467 365.268 906.963 360.814 909.189 352.464",
    fill: "#3f3d56"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "832.641 187.953 829.3 221.357 863.26 226.367 865.765 207.16 868.271 187.953 832.641 187.953",
    fill: "#ffb9b9"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "832.641 187.953 829.3 221.357 863.26 226.367 865.765 207.16 868.271 187.953 832.641 187.953",
    opacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M860.87547,459.89422l18.92843,40.64044s3.34031,18.92842,8.35077,19.48514,10.02093-19.48514,10.02093-19.48514L891.495,489.957l-7.79406-30.06279Z",
    transform: "translate(-102 -112.99772)",
    fill: "#ffb9b9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M900.40247,496.63763l-15.58811,24.49561S869.783,754.3982,872.00984,752.728s9.46421-2.22687,12.2478-6.68062,20.04186,0,20.04186,0l10.02093-10.57764V727.119c0-1.67015,20.04186-129.15864,20.04186-129.15864V630.25s-6.1239,118.581,3.897,117.46756,30.6195-7.79406,30.6195-7.79406,29.50607-221.57388,20.59858-229.92465-12.80452-27.2792-12.80452-27.2792Z",
    transform: "translate(-102 -112.99772)",
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 851.29071,
    cy: 172.08696,
    r: 26.72248,
    fill: "#ffb9b9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M893.72185,339.64307l-3.897-2.22687s-17.25827,11.69109-22.82545,37.85684-9.46422,32.84638-9.46422,32.84638-5.56718,1.11344-1.67015,5.01047,3.897,3.34031.55672,5.56718-5.56718-2.22687-3.34031,2.22687,5.01046,3.34031,2.78359,6.12391-6.1239,2.78359-3.897,5.01046-2.22687,7.23734.55672,9.46421,3.897,2.78359,3.897,6.68062a19.71444,19.71444,0,0,0,1.11343,6.68062h28.94936s-5.56719-10.57765-3.897-12.80452,2.22687-4.45375,1.11343-5.56718-4.45374,1.11343-1.11343-1.67016,4.45374-1.11343,3.34031-4.45374-3.34031-1.67016-1.11344-3.34031,3.897-1.11344,2.78359-2.7836-3.34031-1.67015-1.11343-2.78359,3.897,0,3.34031-2.78359-1.11344-1.67015,0-2.78359,12.80452-38.97028,12.80452-40.08372S893.72185,339.64307,893.72185,339.64307Z",
    transform: "translate(-102 -112.99772)",
    fill: "#d0cde1"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "786.155 339.659 751.081 341.886 759.989 350.237 784.485 350.794 786.155 339.659",
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M898.1756,494.41076,890.93826,507.772s21.712,2.78359,29.50607,5.56718,27.83592,6.68062,27.83592,6.68062l5.01046-19.48514Z",
    transform: "translate(-102 -112.99772)",
    fill: "#3f3d56"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "859.641 387.537 865.765 405.909 890.261 400.898 887.477 383.64 859.641 387.537",
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M971.66241,320.71465s-1.67015-1.11343-5.56718,1.11344-16.70155,3.34031-22.82545-3.34031S932.69213,306.24,931.022,307.35341s-2.78359,13.918-2.78359,13.918l-5.56719,4.45375L889.82483,337.4162l2.78359,75.157,5.01046,17.25827s-3.897,13.36124,1.11344,21.15529-2.78359,10.57765-2.78359,10.57765-1.67016,2.22687-.55672,7.79406-1.11344,26.16576-1.11344,26.16576,47.32106,21.15529,96.869,2.78359l-5.56718-21.1553-2.78359-47.32105s2.78359-7.79406,2.22687-11.13437,16.70155-50.10464,16.70155-50.10464-2.78359-23.38217-17.25827-28.39264-16.70154-10.02093-16.70154-10.02093S974.446,322.94153,971.66241,320.71465Z",
    transform: "translate(-102 -112.99772)",
    fill: "#d0cde1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M926.38294,288.50786s-2.775-4.16248-1.70769-8.64516a26.20163,26.20163,0,0,0,.74711-7.79131A77.11619,77.11619,0,0,1,929.905,260.758c2.24134-4.05576,1.174-5.76344,8.21824-7.04421s4.16248-10.45957,22.73356-.53365a5.44631,5.44631,0,0,0,5.65671,2.13461c3.8423-.74711,5.22979,4.58941,5.22979,4.58941s2.56153-1.49423,3.5221.64038,7.8097-1.28115,7.8097,13.12745-7.79406,27.27919-7.79406,27.27919.57138-24.237-12.12953-26.69179-26.3624-9.60573-29.67105-.42692A69.97228,69.97228,0,0,1,926.38294,288.50786Z",
    transform: "translate(-102 -112.99772)",
    fill: "#2f2e41"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 873.55944,
    cy: 177.9325,
    rx: 2.50523,
    ry: 3.34031,
    fill: "#ffb9b9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M961.36332,737.95091l3.9153,11.74592s0,11.74592,3.91531,17.61888,7.83061,18.5977-7.83061,19.57652-22.513-4.89413-22.513-4.89413,2.93648-7.83061,0-10.76709,0-8.80944,0-8.80944l2.93648-23.49183Z",
    transform: "translate(-102 -112.99772)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M885.0933,737.95091,881.178,749.69683s0,11.74592-3.9153,17.61888-7.83061,18.5977,7.83061,19.57652,22.513-4.89413,22.513-4.89413-2.93648-7.83061,0-10.76709,0-8.80944,0-8.80944l-2.93648-23.49183Z",
    transform: "translate(-102 -112.99772)",
    fill: "#2f2e41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawSolutionMindset34Bi);
export default __webpack_public_path__ + "static/media/undraw_solution_mindset_34bi.35c3a3266e7d10b07b7658e38aeca761.svg";
export { ForwardRef as ReactComponent };